import {Construtor} from './construtor';

export class RegiaoParametroGrafico implements Construtor<RegiaoParametroGrafico> {
  public idRegiaoParametroGrafico: number;
  public idParametroGrafico: number;
  public idRegiaoCliente: number;
  public alterado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof RegiaoParametroGrafico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(tipoPontoFisico: RegiaoParametroGrafico): void {
    this.idRegiaoParametroGrafico = tipoPontoFisico.idRegiaoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idRegiaoCliente = tipoPontoFisico.idRegiaoCliente;
  }

  parseFromJson(tipoPontoFisico: any): void {
    this.idRegiaoParametroGrafico = tipoPontoFisico.idRegiaoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idRegiaoCliente = tipoPontoFisico.idRegiaoCliente;
  }

  modeloCompleto(): boolean {
    return this.idRegiaoCliente !== undefined;
  }

  getNewInstance(object?: any): RegiaoParametroGrafico {
    return new RegiaoParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/regiao-parametro-grafico.ts